<template>
    <div class="personal-cabinet-box" id="personal-cabinet">

        <div class="personal-cabinet" v-show="isAuthorize">
            <div class="button-close pp-icon pp-icon-close" @click="closeCabinet()"></div>
            <div class="personal-cabinet-content">
                <div class="personal-cabinet-title">
                    <div class="pp-icon pp-icon-personal-logo"></div>
                    <div>{{ phrases.TEXT_PERSONAL_CABINET_TITLE }}</div>
                </div>
                <div class="personal-cabinet-header">
                    <div class="personal-buttons__wrapper">
                        <div data-id="#popup-personal-data" class="personal__button button-menu" :class="{'active': cabinetPersonalShowing}" @click="showPersonal()">
                            {{phrases.TEXT_PERSONAL_DATA}}
                        </div>
                        <div data-id="#bonus" class="personal__button button-menu" :class="{'active': cabinetBonusesShowing}" @click="showBonuses()">
                            {{phrases.TEXT_BONUSES}}
                        </div>
                        <div data-id="#address" class="personal__button button-menu" :class="{'active': cabinetAddressesShowing}" @click="showAddresses()">
                            {{phrases.TEXT_ADDRESSES}}
                        </div>
                        <div data-id="#order-history" class="personal__button button-menu button-order-history" :class="{'active': cabinetOrdersShowing}" @click="showOrders()">
                            {{phrases.TEXT_ORDER_HISTORY}}
                        </div>
                    </div>
                </div>

                <div class="personal-cabinet-section" v-show="cabinetPersonalShowing">
                    <div class="personal-cabinet-section__title">
                        {{phrases.TEXT_PROFILE}}
                    </div>
                    <div class="user-personal-data">
                        <div class="form-control">
                            <div class="form-control-title">{{phrases.TEXT_USER_NAME}}:</div>
                            <input :disabled="!isEditProfile" :class="{'editable': isEditProfile}" class="form-control-input" type="text" v-model="name">
                        </div>
                        <div class="form-control">
                            <div class="form-control-title">{{phrases.TEXT_USER_PHONE}}:</div>
                            <input disabled="disabled" class="form-control-input" v-mask="'+7 (###) ###-##-##'" type="text" v-model="phone">
                        </div>
                        <div class="form-control">
                            <div class="form-control-title">Email:</div>
                            <input :disabled="!isEditProfile" :class="{'editable': isEditProfile}" class="form-control-input" type="text" v-model="email">
                        </div>
                        <div class="form-control" data-id="user-birthday-data-field">
                            <div class="form-control-title">{{phrases.TEXT_USER_BDAY}}:</div>
                            <input :disabled="!isEditProfile" :class="{'editable': isEditProfile}" class="form-control-input" v-mask="'##.##.####'" type="text" v-model="birthDay">
                        </div>
                        <div class="error" v-for="(error, index) in errors" :key="index">{{error}}</div>

                        <div class="personal-cabinet-section-buttons">
                            <div class="personal__button button-edit" v-show="!isEditProfile" @click="editProfile()">
                              {{phrases.TEXT_BUTTON_EDIT}}
                            </div>
                            <div class="personal__button button-cancel" :class="{'button-processing': processing}"
                                 v-show="isEditProfile" @click="cancelEdit()">
                              {{phrases.TEXT_BUTTON_CANCEL}}
                            </div>
                            <div class="personal__button button-save" :class="{'button-processing': processing}"
                                 v-show="isEditProfile" @click="saveEdit()">
                              {{phrases.TEXT_BUTTON_SAVE}}</div>
                            <div class="personal__button" @click="logout()">
                              <span v-if="!processing">{{phrases.TEXT_BUTTON_LOGOUT}}</span>
                              <div v-if="processing" class="button-loader"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="address" class="personal-cabinet-section" v-show="cabinetAddressesShowing">
                    <div class="personal-cabinet-section__title">
                        {{phrases.TEXT_ADDRESSES}}
                    </div>
                    <div class="user-address-list" :class="[processing ? 'processing' : '']">
                        <div class="user-address" v-if="!userInfo.addresses.length">{{ phrases.TEXT_NO_SAVE_ADDRESSES }}</div>
                        <div class="user-address" v-for="(address, index) in userInfo.addresses" :key="index">
                            <div class="user-address-title">{{ address.city }}, ул.{{ address.address.street.title }}, д.{{address.address.house}}, под. {{address.address.entrance}}, кв./каб. {{address.address.flat}}</div>
                            <span @click="removeAddress(address.id)" class="user-address-remove">удалить</span>
                        </div>
                    </div>
                </div>

                <div id="bonus" class="personal-cabinet-section personal-cabinet-section-bonus" v-show="cabinetBonusesShowing">
                    <div class="user-bonus">
                        <div class="user-bonus-count">
                            <div class="user-bonus-text">
                                {{phrases.TEXT_YOU_HAVE}}
                                <span class="user-bonus-text-count-value" id="personal-cabinet__user-bonus-count">{{userBonuses}}</span>
                                <span id="personal-cabinet__user-bonus-text">{{bonusText}}</span>
                            </div>
                            <div class="user-bonus-text user-bonus-text-expired">
                                <div class="bonus__expired">{{phrases.TEXT_BONUS_EXPIRED}}</div>
                            </div>
                        </div>

                        <div class="user-bonus-description">
                            <div class="user-bonus-description__title">{{phrases.TEXT_BONUS_PROGRAM_TITLE}}</div>
                            <div class="user-bonus-description-content">
                                <ul class="description-list">
                                    <li class="description-list-item">{{ phrases.TEXT_BONUS_1BONUS_IS_1RUB }}</li>
                                    <li class="description-list-item">{{ phrases.TEXT_BONUS_5_PERCENT }}</li>
                                    <li class="description-list-item">{{ phrases.TEXT_BONUS_10_PERCENT }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <BonusHistory/>
                </div>

                <div id="order-history" class="personal-cabinet-section" v-show="cabinetOrdersShowing">
                    <div class="personal-cabinet-section__title">
                        {{phrases.TEXT_ORDER_HISTORY}}
                    </div>
                    <div class="personal-order-list">
                        <div v-if="processing">{{ phrases.LOADING }}</div>
                        <OrderHistoryItem
                            v-for="(order, index) in orderHistory" :key="'orderItem_' + index"
                                      :orderHistory="order"></OrderHistoryItem>
                    </div>
                </div>
            </div>
        </div>

        <BasketAuth v-bind:classes="{box: 'personal-cabinet personal-cabinet-auth'}" v-if="!isAuthorize">
            <template slot="header">
                <div class="button-close pp-icon pp-icon-close" @click="closeCabinet()"></div>
            </template>
            <template slot="title">
                <div class="personal-cabinet-title">
                    <div class="pp-icon pp-icon-personal-logo"></div>
                    <div>{{ phrases.TEXT_PERSONAL_CABINET_TITLE }}</div>
                </div>
            </template>
        </BasketAuth>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import OrderHistoryItem from "../orderHistory/OrderHistoryItem";
    import BasketAuth from "../basket/Auth";
    import Utils from "../Utils";
    import BonusHistory from "./BonusHistory";

    export default {
        name: "cabinet",
        data: function(){
            return {
                showAuthForm: true,
                showRegistrationForm: false,
                showRepairByEmailForm: false,
                showRepairBySmsForm: false,
                cabinetPersonalShowing: true,
                cabinetAddressesShowing: false,
                cabinetBonusesShowing: false,
                cabinetOrdersShowing: false,
                name: "",
                phone: "",
                email: "",
                birthDay: "",
                isEditProfile: false,
                errors: [],
                processing: false,
            };
        },
        methods: {
            closeCabinet: function () {
                this.$store.commit('app/setShowingCabinet');
            },
            showPersonal: function () {
                this.cabinetPersonalShowing = true;
                this.cabinetAddressesShowing = this.cabinetBonusesShowing = this.cabinetOrdersShowing = false;
            },
            showAddresses: function () {
                this.cabinetAddressesShowing = true;
                this.cabinetPersonalShowing = this.cabinetBonusesShowing = this.cabinetOrdersShowing = false;
            },
            showBonuses: function () {
                this.cabinetBonusesShowing = true;
                this.cabinetPersonalShowing = this.cabinetAddressesShowing = this.cabinetOrdersShowing = false;
                this.fetchBonusHistory();
            },
            showOrders: function () {
                this.cabinetOrdersShowing = true;
                this.cabinetPersonalShowing = this.cabinetAddressesShowing = this.cabinetBonusesShowing = false;
                this.loadOrderHistory();
            },
            editProfile: function () {
                this.isEditProfile = true;
            },
            cancelEdit: function () {
                if(!this.processing){
                    this.isEditProfile = false;
                }
                this.name = this.userInfo.name;
                this.email = this.userInfo.email;
                this.birthDay = this.userInfo.birthday;
            },
            saveEdit: function () {
                const component = this;
                component.errors = [];

                const name = this.name;
                if(this.name === null || this.name.length < 2) {
                    component.errors.push(this.errorText('FILL_NAME'));
                }

                const phoneLength = 11;
                const phone = component.phone.replace(/\D+/g, '').slice(-phoneLength);
                if(phone !== null && phone !== undefined && phone.length !== phoneLength) {
                    component.errors.push(this.errorText('WRONG_PHONE_FORMAT'));
                }

                const email = this.email;
                if(email.length <= 5 || email.search("@") < 0) {
                    component.errors.push(this.errorText('WRONG_EMAIL_FORMAT'));
                }

                const birthDay = this.birthDay;
                if(birthDay !== null && birthDay !== undefined && birthDay.length > 0){
                    if(birthDay.length < 10) {
                        component.errors.push(this.errorText('WRONG_BIRTHDAY_FORMAT'));
                    }
                }

                if(!this.processing) {
                    this.processing = true;
                    this.sendRequest('update-user', {
                      name: name,
                      phone: phone,
                      email: email,
                      birthDay: birthDay,
                      external_id: component.userInfo.external_id
                    }).then(response => {
                        this.processing = false;
                        const data = response.data;
                        if (data.status === 'success') {
                            this.isEditProfile = false;

                            const updateUser = {
                                name: name,
                                email: email,
                                birthday: birthDay,
                            };
                            this.$store.commit('user/changeUserInfo', updateUser);
                            this.$store.commit('order/setUserInfo', {name: name});
                        } else {
                            component.errors.push(this.errorText(data.error));
                        }
                    });
                }
            },
            removeAddress: function (address_id){
              if(!this.processing) {
                this.processing = true;
                this.sendRequest('remove-address', {
                  address_id: address_id,
                  user_id: this.userInfo.id
                }).then(response => {
                  this.processing = false;
                  const data = response.data;
                  if (data.status === 'success') {
                    this.$store.commit('user/removeAddress', address_id);
                  }
                });
              }
            },
            logout: function (){
              const component = this;
              if(!this.processing) {
                component.processing = true;
                component.sendRequest('logout', {}).then(response => {
                  const data = response.data;
                  if (data.status === 'success') {
                    component.$store.commit('user/logout');
                    component.$store.commit("order/setUseBonus", false);
                    component.$store.commit("order/setUseBonusValue", 0);
                    component.updateSessionId(response.headers.session_id);
                  }
                }).finally(() => {
                  component.processing = false;
                });
              }
            },
            loadOrderHistory: function (){
              const component = this;
              if(!this.processing && !this.isOrderHistoryLoaded) {
                this.processing = true;
                this.sendRequest('order-history', {"phone": component.phone, "city_code": component.cityCode}).then(response => {
                  this.processing = false;
                  const data = response.data;
                  if (data.status) {
                    this.$store.commit('user/setOrderHistory', data.orders);
                  } else {
                    this.errors.push(this.errorText(data.error));
                  }
                });
              }
            },
            fetchBonusHistory: function () {
              const components = this;
              components.requestWaiting = true;
              if (components.userExternalId !== null && !components.isBonusHistoryLoaded) {
                components.sendRequest('bonus-history', {user_id: components.userExternalId}, "GET").then(response => {
                  components.$store.commit("user/setIsBonusHistoryLoaded");
                  components.$store.commit("user/setBonusHistory", response.data);
                }).finally(function (){
                  components.requestWaiting = false;
                });
              }
            }
        },
        watch: {
            userInfo: {
                handler: function(user) {
                    this.name = user.name;
                    this.email = user.email;
                    this.birthDay = user.birthday;
                    if(this.phone === null || this.phone.length === 0) {
                      this.phone = user.phone.substr(-10);
                    }
                },
                deep: true,
            }
        },
        computed:{
            ...mapGetters('user', {
                isAuthorize: 'isAuthorize',
                userBonuses: 'getBonuses',
                userInfo: 'getInfo',
                orderHistory: 'getOrderHistory',
                isOrderHistoryLoaded: 'getOrderHistoryLoaded',
                isBonusHistoryLoaded: 'isBonusHistoryLoaded',
                userExternalId: 'getExternalId'
            }),
            ...mapGetters('app', {
                phrases: 'getPhrases',
                cityCode: 'getCityCode',
            }),
            bonusText: function () {
                return this.morph(this.userBonuses, this.phrases.PROSTO_BONUS, this.phrases.PROSTO_BONUS_2, this.phrases.PROSTO_BONUSES);
            }
        },
        components: {BonusHistory, BasketAuth, OrderHistoryItem},
        mounted() {
            this.name = this.userInfo.name;
            this.email = this.userInfo.email;
            this.phone = this.userInfo.phone.substr(-10);
            this.birthDay = this.userInfo.birthday;
        },
        mixins:[Utils],
        destroyed() {
            this.addFixedBodyClass(false);
        }
    }
</script>

<style scoped lang="scss">
</style>
